/**
 * Enumeration of each of the tiers that have an associated tier set bonus.
 * This follows the format of "<short expansion name><season number>".
 */
export enum TIERS {
  // Nerubar Palace
  TWW1,
  // Liberation of Undermine
  TWW2,
  // Manaforge Omega
  TWW3,
  // Void Spire / Dreamrift / March on Quel'Danas
  MID1,
}
